import React, { Component } from 'react';

import brandingStyles from '../branding/brandingStyles';

// LoadingSpinner Component
class LoadingSpinner extends Component {
    render() {
        return (
         <div className="spinner" style={brandingStyles.fontColor}>
           <i className="fa fa-refresh fa-spin"/>
         </div>
        );
    }
}

export default LoadingSpinner;



/** WEBPACK FOOTER **
 ** ./src/components/LoadingSpinner.js
 **/